export const icons = (item) => {
  const campaign = item;
  const contentGroups = campaign.contentGroups;

  const generateIcons = (contentGroups) => {
    return contentGroups.map(contentGroup => {
      const contents = contentGroup.contents;
      if (contents.length === 0) {
        return '';
      }
      const content = contents[0];
      let html = '';

      if (campaign.frame === "circle") {
        html += `<div class="storeeel_campaign storeeel-icon campaign_${campaign.id} storeeel_campaign_circle" id="storeeel-icon-${contentGroup.id}" data-type="${contentGroup.name}" group-name="${contentGroup.name}">`
      } else {
        html += `<div class="storeeel_campaign storeeel-icon-square campaign_${campaign.id}" id="storeeel-icon-${contentGroup.id}" data-type="${contentGroup.name}" group-name="${contentGroup.name}">`
      }

      if (campaign.frame === "square") {
        if (content.mediaAsset.attachmentData.metadata.mime_type.includes('image')) {
          html += `
            <div
              class="storeeel-content storeeel-content-image"
              id="storeeel-content-${content.id}"
              style="background-image: url('${content.mediaAsset.mediaUrl}'); background-size: cover; background-position: center; background-repeat: no-repeat;"
              role="img"
              aria-label="${contentGroup.name}"
            ></div>
          `;
        } else if (content.mediaAsset.attachmentData.metadata.mime_type.includes('video')) {
          html += `
            <video
              class="storeeel-content storeeel-content-movie"
              id="storeeel-content-${content.id}"
              src="${content.mediaAsset.mediaUrl}#t=0.1"
              playsinline
              muted
              loop
            ></video>
          `;
        }
      } else {
        const imageUrl = contentGroup.imageUrl || (content.mediaAsset.attachmentData.metadata.mime_type.includes('image') ? content.mediaAsset.mediaUrl : null);
        if (imageUrl) {
          html += `
            <div
              class="storeeel-icon storeeel-content-image"
              id="storeeel-content-${content.id}"
              style="background-image: url('${imageUrl}'); background-size: cover; background-position: center; background-repeat: no-repeat;"
              role="img"
              aria-label="${contentGroup.name}"
            ></div>
          `;
        } else if (content.mediaAsset.attachmentData.metadata.mime_type.includes('video')) {
          html += `
            <video
              class="storeeel-icon storeeel-content-movie"
              id="storeeel-content-${content.id}"
              src="${content.mediaAsset.mediaUrl}#t=0.1"
              playsinline
              muted
              loop
              style="border-radius: 50%;object-fit: cover; display: block;"
            ></video>
          `;
        }

        html += `
          <div class="storeeel_campaign_group_name">${contentGroup.name}</div>
        `;
      }

      html += `</div>`;
      return html;
    }).join('');
  };

  const style = () => {
    if (campaign.frame === "square") {
      return `
        .storeeel_campaign {
          flex: 0 0 auto;
          position: relative;
          display: inline-block;
        }
        .storeeel-content {
          border-radius: 10px;
          height: 324px;
          width: 182px;
          margin: 0px 5px;
          cursor: pointer;
        }
        .storeeel-content-image {
          background-size: cover;
          background-position: center;
          background-repeat: no-repeat;
          vertical-align: baseline;
        }
        .storeeel-content-movie {
          max-width: none;
          vertical-align: top;
        }
      `;
    } else {
      return `
        .storeeel-icon {
          background-size: cover;
          background-repeat: no-repeat;
          background-position: center;
          width: 80px;
          height: 80px;
          border-radius: 50%;
          flex-shrink: 0;
          cursor: pointer;
        }
        .storeeel_campaign_circle {
          display: flex;
          width: 100px;
          height: 116px;
          flex-direction: column;
          justify-content: flex-start;
          gap: 7px;
          align-items: center;
        }
        .storeeel_campaign_circle .storeeel-icon {
          border: 1px solid #e0e0e0;
        }
        .storeeel_campaign_group_name {
          display: -webkit-box;
          width: 92px;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: normal;
          color: var(--Black-100, #272727);
          text-align: center;
          font-size: 12px;
          font-style: normal;
          font-weight: 500;
          line-height: 1.2;
          word-break: break-all;
          letter-spacing: 0px;
        }
      `;
    }
  }

  const iconsHTML = `
    ${generateIcons(contentGroups)}
    <style>
      ${style()}
    </style>
  `;

  return iconsHTML;
}

export const setupVideoIntersectionObserver = () => {
  const ua = navigator.userAgent.toLowerCase();
  const isMobile = /iphone|ipod|android.*mobile|windows phone/.test(ua);

  const videos = document.querySelectorAll('.storeeel-content-movie');

  if (!isMobile) {
    // Desktop: hover to play/pause
    videos.forEach(video => {
      video.addEventListener('mouseenter', () => {
        video.currentTime = 0;
        video.play();
      });
      video.addEventListener('mouseleave', () => {
        video.pause();
        video.currentTime = 0;
      });
    });
    return;
  }

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      const video = entry.target;
      if (entry.isIntersecting) {
        video.currentTime = 0;
        video.play();
      } else {
        video.pause();
        video.currentTime = 0;
      }
    });
  }, {
    root: null,
    threshold: 0.9
  });

  videos.forEach(video => {
    observer.observe(video);
  });
};
